// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeIntro_home-intro__rXpDp {
  display: flex;
  height: calc(65vh - var(--navbar-height));
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  background: linear-gradient(90deg, #E0E7FF 0%, #FFFFFF 50%, #FFF7ED 100%);
  overflow: hidden;
}
.HomeIntro_home-intro--background-image__OzB2K {
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 65%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
  mask-image: linear-gradient(to left, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%);
  -webkit-mask-image: linear-gradient(to left, rgb(0, 0, 0) 20%, rgba(0, 0, 0, 0) 100%);
  z-index: 0;
}
.HomeIntro_home-intro__rXpDp .HomeIntro_home-intro__container__D86fw {
  display: flex;
  padding-top: 150px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  flex: 1 0;
  align-self: stretch;
  position: relative;
  z-index: 1;
}
.HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--title__iOubg {
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: var(--accent-color);
  color: #fff;
  font-size: 52px;
  font-weight: 700;
  max-width: 900px;
  line-height: 1.2;
}
.HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--title__iOubg span {
  color: var(--accent-color);
}
.HomeIntro_home-intro--search__DMqV1 {
  height: 56px;
  padding: 0 28px;
  border-radius: 9999px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--light-grey);
  background: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
  width: 73%;
}
.HomeIntro_home-intro--search__DMqV1:focus-within {
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
}
.HomeIntro_home-intro--search__wrapper__vwv\\+K {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}
.HomeIntro_home-intro--search--dropdown__HuGMM {
  border-right: 1px solid var(--accent-color);
}
.HomeIntro_home-intro--search--dropdown__HuGMM:hover::before, .HomeIntro_home-intro--search--dropdown__HuGMM:hover::after {
  border-bottom: none !important;
}
.HomeIntro_home-intro--search--dropdown__HuGMM::before, .HomeIntro_home-intro--search--dropdown__HuGMM::after {
  border-bottom: none !important;
}
.HomeIntro_home-intro--search--input__Injc5 {
  flex: 1 1;
}
.HomeIntro_home-intro--search--input__Injc5:hover::before, .HomeIntro_home-intro--search--input__Injc5:hover::after {
  border-bottom: none !important;
}
.HomeIntro_home-intro--search--input__Injc5::before, .HomeIntro_home-intro--search--input__Injc5::after {
  border-bottom: none !important;
}
.HomeIntro_home-intro--suggestions__6X4IR {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  position: absolute;
  top: 367px;
  left: 19%;
  width: 47%;
  z-index: 10;
  background-color: #ffffff;
}
.HomeIntro_home-intro--suggestions__6X4IR:empty {
  display: none;
}
.HomeIntro_home-intro--suggestions--loading__cuP\\+t {
  position: absolute;
  width: 100%;
  top: 56px;
  color: var(--accent-color);
  height: 2px;
}
.HomeIntro_home-intro--suggestions--item__yk1aK {
  align-self: stretch;
  display: flex !important;
  padding: 8px 28px !important;
  justify-content: center !important;
  align-items: center !important;
  border-radius: 0 !important;
  border-bottom: 1px solid var(--light-grey) !important;
  color: var(--accent-color) !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: initial !important;
  justify-content: initial !important;
}
@media only screen and (min-width: 1580px) {
  .HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--suggestions__6X4IR {
    left: 27%;
    width: 35%;
  }
}
@media only screen and (max-width: 1280px) {
  .HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--suggestions__6X4IR {
    left: 14%;
    width: 55%;
  }
}
@media only screen and (max-width: 480px) {
  .HomeIntro_home-intro__rXpDp .HomeIntro_home-intro__container__D86fw {
    padding-top: 100px;
  }
  .HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--title__iOubg {
    text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
    font-size: 36px;
  }
  .HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--search__DMqV1 {
    height: 40px;
    padding: 0 15px 0 20px;
  }
  .HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--search__DMqV1 .MuiInput-input {
    padding: 0;
  }
  .HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--search--dropdown__HuGMM {
    font-size: 14px;
  }
  .HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--search--input__Injc5 {
    font-size: 14px;
  }
  .HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--suggestions--loading__cuP\\+t {
    top: 40px;
  }
  .HomeIntro_home-intro__rXpDp .HomeIntro_home-intro--suggestions--item__yk1aK {
    padding: 8px 20px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeIntro/HomeIntro.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yCAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yEAAA;EACA,gBAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,UAAA;EACA,4EAAA;EACA,qFAAA;EACA,UAAA;AACJ;AAGI;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AADN;AAII;EACE,4CAAA;EACA,8BAAA;EACA,8CAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAFN;AAIM;EACE,0BAAA;AAFR;AAQE;EACI,YAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,mCAAA;EACA,gBAAA;EACA,0CAAA;EACA,gCAAA;EACA,UAAA;AANN;AAQM;EACE,0CAAA;AANR;AASM;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AAPR;AAUM;EACE,2CAAA;AARR;AAYU;EAEE,8BAAA;AAXZ;AAeQ;EAEE,8BAAA;AAdV;AAkBM;EACE,SAAA;AAhBR;AAoBU;EAEE,8BAAA;AAnBZ;AAuBQ;EAEE,8BAAA;AAtBV;AA0BE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AAxBJ;AA0BI;EACE,aAAA;AAxBN;AA2BI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;EACA,WAAA;AAzBN;AA4BI;EACE,mBAAA;EACA,wBAAA;EACA,4BAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qDAAA;EACA,qCAAA;EACA,0BAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;AA1BN;AA6BE;EAEI;IACE,SAAA;IACA,UAAA;EA5BN;AACF;AA+BE;EAEI;IACE,SAAA;IACA,UAAA;EA9BN;AACF;AAkCE;EAEI;IACE,kBAAA;EAjCN;EAoCI;IACE,4CAAA;IACA,eAAA;EAlCN;EAqCI;IACE,YAAA;IACA,sBAAA;EAnCN;EAqCM;IACE,UAAA;EAnCR;EAsCM;IACE,eAAA;EApCR;EAuCM;IACE,eAAA;EArCR;EAyCM;IACE,SAAA;EAvCR;EA0CM;IACE,iBAAA;IACA,eAAA;EAxCR;AACF","sourcesContent":[".home-intro {\n  display: flex;\n  height: calc(65vh - var(--navbar-height));\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  align-self: stretch;\n  background: linear-gradient(90deg, #E0E7FF 0%, #FFFFFF 50%, #FFF7ED 100%);\n  overflow: hidden;\n\n  &--background-image {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 50%;\n    height: 65%;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    opacity: 1;\n    mask-image: linear-gradient(to left, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);\n    -webkit-mask-image: linear-gradient(to left, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 0) 100%);\n    z-index: 0;\n  }\n\n  .home-intro {\n    &__container {\n      display: flex;\n      padding-top: 150px;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 40px;\n      flex: 1 0 0;\n      align-self: stretch;\n      position: relative;\n      z-index: 1;\n    }\n\n    &--title {\n      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      -webkit-text-stroke-width: 1px;\n      -webkit-text-stroke-color: var(--accent-color);\n      color: #fff;\n      font-size: 52px;\n      font-weight: 700;\n      max-width: 900px;\n      line-height: 1.2;\n\n      span {\n        color: var(--accent-color);\n      }\n    }\n\n    \n  }\n  &--search {\n      height: 56px;\n      padding: 0 28px;\n      border-radius: 9999px;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 8px;\n      border: 1px solid var(--light-grey);\n      background: #fff;\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n      transition: box-shadow 0.3s ease;\n      width: 73%;\n\n      &:focus-within {\n        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);\n      }\n\n      &__wrapper {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        width: 100%;\n      }\n\n      &--dropdown {\n        border-right: 1px solid var(--accent-color);\n\n        &:hover {\n\n          &::before,\n          &::after {\n            border-bottom: none !important;\n          }\n        }\n\n        &::before,\n        &::after {\n          border-bottom: none !important;\n        }\n      }\n\n      &--input {\n        flex: 1;\n\n        &:hover {\n\n          &::before,\n          &::after {\n            border-bottom: none !important;\n          }\n        }\n\n        &::before,\n        &::after {\n          border-bottom: none !important;\n        }\n      }\n    }\n  &--suggestions {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    align-self: stretch;\n    position: absolute;\n    top: 367px;\n    left: 19%;\n    width: 47%;\n    z-index: 10;\n    background-color: #ffffff;\n\n    &:empty {\n      display: none;\n    }\n\n    &--loading {\n      position: absolute;\n      width: 100%;\n      top: 56px;\n      color: var(--accent-color);\n      height: 2px;\n    }\n\n    &--item {\n      align-self: stretch;\n      display: flex !important;\n      padding: 8px 28px !important;\n      justify-content: center !important;\n      align-items: center !important;\n      border-radius: 0 !important;\n      border-bottom: 1px solid var(--light-grey) !important;\n      color: var(--accent-color) !important;\n      font-size: 16px !important;\n      font-weight: 600 !important;\n      text-transform: initial !important;\n      justify-content: initial !important;\n    }\n  }\n  @media only screen and (min-width: 1580px) {\n    .home-intro {\n      &--suggestions {\n        left: 27%;\n        width: 35%;\n      }\n    }\n  }\n  @media only screen and (max-width: 1280px) {\n    .home-intro {\n      &--suggestions {\n        left: 14%;\n        width: 55%;\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    .home-intro {\n      &__container {\n        padding-top: 100px;\n      }\n\n      &--title {\n        text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);\n        font-size: 36px;\n      }\n\n      &--search {\n        height: 40px;\n        padding: 0 15px 0 20px;\n\n        :global(.MuiInput-input) {\n          padding: 0;\n        }\n\n        &--dropdown {\n          font-size: 14px;\n        }\n\n        &--input {\n          font-size: 14px;\n        }\n      }\n      &--suggestions {\n        &--loading {\n          top: 40px;\n        }\n\n        &--item {\n          padding: 8px 20px;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-intro": `HomeIntro_home-intro__rXpDp`,
	"home-intro--background-image": `HomeIntro_home-intro--background-image__OzB2K`,
	"home-intro__container": `HomeIntro_home-intro__container__D86fw`,
	"home-intro--title": `HomeIntro_home-intro--title__iOubg`,
	"home-intro--search": `HomeIntro_home-intro--search__DMqV1`,
	"home-intro--search__wrapper": `HomeIntro_home-intro--search__wrapper__vwv+K`,
	"home-intro--search--dropdown": `HomeIntro_home-intro--search--dropdown__HuGMM`,
	"home-intro--search--input": `HomeIntro_home-intro--search--input__Injc5`,
	"home-intro--suggestions": `HomeIntro_home-intro--suggestions__6X4IR`,
	"home-intro--suggestions--loading": `HomeIntro_home-intro--suggestions--loading__cuP+t`,
	"home-intro--suggestions--item": `HomeIntro_home-intro--suggestions--item__yk1aK`
};
export default ___CSS_LOADER_EXPORT___;
